import { render, staticRenderFns } from "./HomeCollection.vue?vue&type=template&id=383a1af8&lang=pug&"
import script from "./HomeCollection.vue?vue&type=script&lang=js&"
export * from "./HomeCollection.vue?vue&type=script&lang=js&"
import style0 from "./HomeCollection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('383a1af8')) {
      api.createRecord('383a1af8', component.options)
    } else {
      api.reload('383a1af8', component.options)
    }
    module.hot.accept("./HomeCollection.vue?vue&type=template&id=383a1af8&lang=pug&", function () {
      api.rerender('383a1af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/home/HomeCollection.vue"
export default component.exports